import TripCheckoutPaymentService from './trip-checkout-payment-service';

const MODULE_NAME = 'trip.checkout.payment';
const module = angular.module(MODULE_NAME, [])
    .service(TripCheckoutPaymentService.SERVICE_NAME, TripCheckoutPaymentService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment/trip-checkout-payment-module.js